import {observer} from 'mobx-react-lite'
import appStore from '../../../storage/AppStore'
import {useLocation} from 'react-router-dom'
import clubStore from '../../../storage/ClubStore'
import {useEffect} from 'react'
import PageLayout from '../../PageLayout'
import Select from '../../../ui/Select'
import Btn from '../../../ui/Btn'
import './parent.css'
import AttendanceItem from '../ParentMember/AttendanceItem'

const Attendance = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (clubStore.parent.children.length === 0) {
      clubStore.parent.getChildren().then(() => {
        clubStore.parent.getAttendance()
      })
    }
    if (clubStore.parent.child_id) {
      clubStore.parent.getAttendance()
    }
  }, [location.pathname])
  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className="m-0">{appStore.tr.attendance}</h3>
      </div>
    } filters={
      <div className="col-12 grid">
        <div className="col-8">
          <Select store={clubStore.parent} prop="child_id"
                  options={clubStore.parent.children}
                  optionLabel={"title"}
                  optionValue={"id"}
                  id={"input_child"}
                  label={appStore.tr.child}
          />
        </div>
        <div className="col-4">
          <Btn icon={"pi pi-search"} label={appStore.tr.search} onClick={() => {
            clubStore.parent.getAttendance()
          }} disabled={!clubStore.parent.child_id}/>
        </div>
      </div>
    }>
      <div className="grid">
        {clubStore.parent.attendance.map((period, idx) => (
          <AttendanceItem period={period} key={idx} />
        ))}
      </div>
    
    </PageLayout>
  );
}
export default observer(Attendance)